import React from "react";
import NavPanel from "../../Common/Nav/NavPanel.jsx";
import TeamDetailsPanel from "./TeamDetailsPanel.jsx";
import TeamDetailsPanelNotSupported from "./TeamDetailsPanelNotSupported.jsx";
import HeadToHead from "../../HeadToHead/HeadToHead.jsx";
import ClassificationList from "../Containers/ClassificationListContainer";
import FreeGameAdContainer from "../../FreeGameAd/FreeGameAdContainer";
import {FormattedMessage} from "react-intl";

const TeamDetails = ({
    ownTeams,
    team,
    onHeadToHeadClick,
    game,
    showHth
}) => {
    if (!team) {
        return null;
    }
    if (team.notSupported) {
        return <div className="team-details">
            <div className="team-details__container">
                <TeamDetailsPanelNotSupported team={team} game={game}/>
            </div>
        </div>;
    }

    let hthRef = null;

    return <div className="team-details">
        <ClassificationList/>
        <FreeGameAdContainer/>
        <div className="team-details__container clearfix">
            <TeamDetailsNav ownTeams={ownTeams} game={game} team={team}/>
            <div className="team-details__teams-panel">
                <TeamDetailsPanel
                    game={game}
                    team={team}
                    onHeadToHeadClick={
                        ()=> {
                            hthRef && hthRef.ensureVisible();
                            onHeadToHeadClick(team)
                        }
                    }
                />
                {showHth ? <HeadToHead show={showHth} ref={ref => hthRef = ref}/> : null}
            </div>
        </div>
    </div>;
};

const TeamDetailsNav = ({ownTeams, game}) => {
    if (!ownTeams) {
        return null;
    }
    return(<div className="team-details__teams-nav"><FormattedMessage id="details.myTeams">
    {message =><NavPanel
        name={message}
        items={ownTeams.map(team => ({...team, url: `/results/${game.id}/team/${team.id}`}))}
        itemType="routing"
    />}
    </FormattedMessage>
</div>) 
;
};

export default TeamDetails;